// Single source of truth for byte ↔ hex conversion across vault.
// Production callers (onboarding HTTP, gateway auth) and test helpers
// (lib/signing/sign.ts) all import from here — keeps the byte-order
// assumption in one place and avoids drift between copies.
//
// Wire format is raw lowercase hex (no `0x` prefix, no encoding
// wrapper) so the value is stored byte-for-byte as-is throughout the
// pipeline.

export function bytesToHex(b: Uint8Array): string {
  let s = '';
  for (let i = 0; i < b.length; i++) s += (b[i] as number).toString(16).padStart(2, '0');
  return s;
}
